import { GraphSchema } from '@ta/server';

export enum eMediaType {
  Unknown = 0,
  Image = 1,
  Document = 2,
}

export enum DocumentMediaType {
  Unknown = 0,
  Inventory = 1,
  Meters = 2,
  Other = 3,
  RentalLease = 4,
  Works = 5,
  Insurances = 6,
}
export interface Media {
  id: string;
  url: string;
  filename: string;
  description: string;
  documentType: DocumentMediaType;
  size: number;
  createdDate: string;
}

export const mediaProps = new GraphSchema<Media>([
  'id',
  'url',
  'filename',
  'description',
  'documentType',
  'size',
  'createdDate',
]);

export const mediaPropsComposition = `
    ${mediaProps.get('id')}
    ${mediaProps.get('filename')}
    ${mediaProps.get('url')}
    ${mediaProps.get('description')}
    ${mediaProps.get('documentType')}
    ${mediaProps.get('createdDate')}
    ${mediaProps.get('size')}
`;
